var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "90vh"
        }
      },
      on: {
        hide: function($event) {
          return _vm.hideModal()
        }
      },
      model: {
        value: _vm.show_modal,
        callback: function($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    return _vm.hideModal()
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.material.title) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row gutter-md" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c(
                    "q-card",
                    { staticClass: "full-height" },
                    [
                      _c(
                        "q-card-actions",
                        { staticClass: "justify-center" },
                        [
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              label: _vm.material.size,
                              icon: "far fa-hdd"
                            }
                          }),
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              label: _vm.material.hits,
                              icon: "fas fa-download"
                            }
                          }),
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              label: _vm.material.extension,
                              icon: _vm.$extensionIcon(_vm.material.extension)
                            }
                          })
                        ],
                        1
                      ),
                      _c("q-card-separator"),
                      _c(
                        "q-card-actions",
                        { staticClass: "justify-center" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width q-my-sm",
                            attrs: {
                              label: _vm.$t("download"),
                              icon: "fas fa-download",
                              color: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-8" },
                [
                  _c(
                    "q-card",
                    [
                      _c(
                        "q-card-main",
                        { staticClass: "card-players" },
                        [
                          _vm.showPlayer(["pdf"])
                            ? _c("pdf-player", {
                                attrs: {
                                  file_url: _vm.material.resource_url,
                                  file_preview: _vm.material.file_preview,
                                  change_state: _vm.material.change_state
                                }
                              })
                            : _vm.showPlayer([
                                "ppt",
                                "pptx",
                                "doc",
                                "docx",
                                "xls",
                                "xlsx"
                              ])
                            ? _c("office-player", {
                                attrs: { file_url: _vm.material.resource_url }
                              })
                            : _vm.showPlayer([
                                "jpg",
                                "jpeg",
                                "png",
                                "gif",
                                "bmp",
                                "svg"
                              ])
                            ? _c("image-player", {
                                attrs: { file_url: _vm.material.resource_url }
                              })
                            : _vm.showPlayer(["mp4"])
                            ? _c("video-player", {
                                attrs: {
                                  file_url: _vm.material.resource_url,
                                  id: _vm.material.id
                                }
                              })
                            : _c("div", { staticClass: "q-mt-xl" }, [
                                _c(
                                  "p",
                                  [
                                    _c("q-icon", {
                                      attrs: {
                                        name: "far fa-eye-slash",
                                        size: "3rem"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "q-display-1 text-weight-medium"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "no_pre_visualization_avaliable"
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }